import { UrlSegment } from "@angular/router";

export const isAgentActionRoute = (url: UrlSegment[]) => url[0]?.path == 'lead' && url.length > 1 ? ({ consumed: url }) : null
